'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PlotlyIconBase = function PlotlyIconBase(_ref) {
    var children = _ref.children,
        width = _ref.width,
        height = _ref.height,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        props = _objectWithoutProperties(_ref, ['children', 'width', 'height', 'style']);

    return _react2.default.createElement('svg', _extends({
        children: children,
        fill: 'currentColor',
        preserveAspectRatio: 'xMidYMid meet',
        height: height,
        width: width,
        style: style
    }, props));
};

PlotlyIconBase.propTypes = {
    children: _propTypes2.default.node.isRequired,
    width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    style: _propTypes2.default.object
};

exports.default = PlotlyIconBase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/IconBase.js
// module id = 3
// module chunks = 0